import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { UserServiceDepricated } from '../stores/user/user.service';

/**
 * Format date to time ago.
 *
 * @export
 */
@Pipe({
  name: 'dateAgo'
})
export class DateAgoPipe implements PipeTransform {

  /** Constructor. */
  constructor(
    private userServiceDepricated: UserServiceDepricated
  ) { }

  /**
   * Format date to time ago.
   *
   * @param value Date as ISO string.
   */
  transform(value: any) {
    moment.locale(this.userServiceDepricated.getActive().userLanguage);
    return moment(value).fromNow();
  }
}
